import { render, staticRenderFns } from "./HelpPopUp.vue?vue&type=template&id=1a5f3d17&scoped=true&lang=pug&"
import script from "./HelpPopUp.vue?vue&type=script&lang=js&"
export * from "./HelpPopUp.vue?vue&type=script&lang=js&"
import style0 from "./HelpPopUp.vue?vue&type=style&index=0&id=1a5f3d17&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5f3d17",
  null
  
)

export default component.exports